// Route guards.
//
// RequireAuth — blocks children until the boot refresh settles; bounces anonymous
// users to /login.
// RequireAdmin — additionally gates on the JWT role claim. If the authenticated
// principal is NOT admin/security-officer, render the "無權限" screen (DeniedPage)
// instead of the console. This is a UI gate only; the server's requireAdmin is the
// real enforcement (LOCKED rules), so individual API calls may still 403.

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAdminRole, useAuth } from './AuthContext';
import DeniedPage from '../features/denied/DeniedPage';

function BootScreen() {
  return (
    <div className="state-block" style={{ minHeight: '100vh' }}>
      <div className="spinner" />
      <div className="text-secondary">載入中…</div>
    </div>
  );
}

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'booting') return <BootScreen />;
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

/** Must run INSIDE RequireAuth (assumes status === 'authenticated'). */
export function RequireAdmin() {
  const { role } = useAuth();
  if (!isAdminRole(role)) return <DeniedPage />;
  return <Outlet />;
}
